import React from 'react';
import { IconType } from 'react-icons';

interface IconWrapperProps extends Omit<React.SVGProps<SVGSVGElement>, 'ref'> {
  icon: IconType;
  style?: React.CSSProperties;
}

export const IconWrapper = React.forwardRef<HTMLSpanElement, IconWrapperProps>(
  ({ icon: Icon, style, ...props }, ref) => {
    const IconComponent = Icon as React.ComponentType<React.SVGProps<SVGSVGElement>>;
    return (
      <span ref={ref} style={style}>
        <IconComponent {...props} />
      </span>
    );
  }
); 